import MatchMedia from '../../ui/MatchMedia/MatchMedia';
import ImageGalleryHeadlineDesktop from './ImageGalleryHeadlineDesktop/ImageGalleryHeadlineDesktop';
import ImageGalleryHeadlineMobile from './ImageGalleryHeadlineMobile/ImageGalleryHeadlineMobile';

const ImageGalleryHeadLine = (props) => {
  return (
    <MatchMedia
      content={{
        mobile: () => <ImageGalleryHeadlineMobile {...props} />,
        tablet: () => <ImageGalleryHeadlineMobile {...props} />,
        desktop: () => <ImageGalleryHeadlineDesktop {...props} />,
      }}
    />
  );
};

export default ImageGalleryHeadLine;
